import noop from 'lodash/noop';
import React from 'react';

import styles from '@commons/Dropdown/dropdown.scss';

import stripHtml from '@utils/stripHtml';
import { testName } from '@utils/testUtils';

interface NativeLanguageSelectorProps {
  languages?: {
    name?: string;
    key?: string;
  }[];
  surveyLanguage?: string;
  label?: string;
  onLanguageSelected?: (...args: unknown[]) => unknown;
}

const NativeLanguageSelector = ({
  label = '',
  languages = [],
  surveyLanguage = 'en',
  onLanguageSelected = noop
}: NativeLanguageSelectorProps) => {
  const onChangeHandler = (event) => {
    onLanguageSelected(event.target.value);
  };

  if (languages.length === 0) {
    return null;
  }

  return (
    <span>
      {label && (
        <label htmlFor="activeLang" className={styles.dropdownLabel_isInactive}>
          {label}
        </label>
      )}
      <select value={surveyLanguage} onChange={onChangeHandler} aria-label={label}>
        {languages.map((langOption) => (
          <option
            value={langOption.key}
            key={langOption.key}
            {...testName(stripHtml(langOption.name), 'option')}>
            {stripHtml(langOption.name)}
          </option>
        ))}
      </select>
    </span>
  );
};

export default NativeLanguageSelector;
